/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { checkRol } from '../security';
import { aprobador } from '../security/constantsRols';
import {
  getImputationType,
  getBusinessUnits,
  getAllBusinessUnits,
  getEvents,
  getOperationsOyM,
  typeUbicationSS,
  getAllOperations,
  getEventsByAsignment
} from '../services/yclickMaster';
import { useFilterContext } from '../context/FilterContext';
import { eventAsignmentEnum, ubicationTypeEnum } from '../utils/dataStatus';
import { getPriorities, statusSS } from '../services/serviceRequest';

import useToast from './useToast';

// OperationResult se ultiliza para obtener ids de operaciones en GenerateTemplate

// The asignmentType can be 1, for all, 2 for pending and 3 for asigned
const useLoadServices = (
  { asignmentType, createSDS = false } = { asignmentType: eventAsignmentEnum.all }
) => {
  const [businessUnitSelect, setBusinessUnitSelect] = useState([]);
  const [operationsSelect, setOperationsSelect] = useState([]);
  const [eventTypeSelect, setEventTypeSelect] = useState([]);
  const [imputationTypeSelect, setImputationTypeSelect] = useState([]);
  const [statusSelect, setStatusSelect] = useState([]);
  const [eventsSelect] = useState([]);
  const [eventWithAsignment, setEventWithAsignment] = useState([]);
  const [ubicationTypeSelect, setUbicationTypeSelect] = useState([]);
  const [prioritySelect, setPrioritySelect] = useState([]);
  const { setNewToast } = useToast();
  const filterContext = useFilterContext();
  const formikFilters = filterContext?.formikFilters;
  const values = formikFilters?.values;

  const location = useLocation();
  const approverRoute = location.pathname === '/approver';

  const isApprover = checkRol(aprobador) && approverRoute;

  const isOyM = values?.tipoUbicacionEnum?.id
    ? values?.tipoUbicacionEnum?.id !== ubicationTypeEnum.pozo &&
      values?.tipoUbicacionEnum?.id !== ubicationTypeEnum.locacion
    : false;

  const getDataSelects = async () => {
    try {
      if (isApprover) {
        const eventTypeResult = await getEvents({ sinAsignacion: true });

        setEventTypeSelect(eventTypeResult);

        const businessUnitResult = await getAllBusinessUnits();

        setBusinessUnitSelect(businessUnitResult);
      } else {
        const statusResult = await statusSS();

        setStatusSelect(statusResult);

        const businessUnitResult = await getBusinessUnits();

        setBusinessUnitSelect(businessUnitResult);

        const operationsResult = await getAllOperations();

        setOperationsSelect(operationsResult);

        const priorities = await getPriorities();

        setPrioritySelect(priorities);
      }

      const ubicationTypeResult = await typeUbicationSS(!!createSDS);

      setUbicationTypeSelect(ubicationTypeResult);

      const imputationTypeResult = await getImputationType();

      setImputationTypeSelect(imputationTypeResult);

      // const eventsResult = await getEvents({ sinAsignacion: false });
      // const eventsMapped = eventsResult.map((event) => ({
      //   ...event,
      //   nombre: event?.sigla ? `${event?.nombre} - ${event?.sigla}` : event?.nombre
      // }));

      // setEventsSelect(eventsMapped);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const getAndSetEventsByAsignment = async () => {
    try {
      const eventWithAsignmentReponse = await getEventsByAsignment({ asignmentType });

      setEventWithAsignment(eventWithAsignmentReponse);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  useEffect(() => {
    getDataSelects();
  }, []);

  useEffect(() => {
    getAndSetEventsByAsignment();
  }, [asignmentType]);

  useEffect(() => {
    if (isOyM) {
      getOperationsOyM({ tipoUbicacionId: values?.tipoUbicacionEnum.id })
        .then(setBusinessUnitSelect)
        .catch((err) =>
          setNewToast({
            type: 'ERROR',
            message: err.message
          })
        );
    } else {
      getBusinessUnits()
        .then(setBusinessUnitSelect)
        .catch((err) =>
          setNewToast({
            type: 'ERROR',
            message: err.message
          })
        );
    }
  }, [isOyM, values?.tipoUbicacionEnum?.id]);

  return {
    businessUnitSelect,
    operationsSelect,
    eventTypeSelect,
    imputationTypeSelect,
    statusSelect,
    eventsSelect,
    ubicationTypeSelect,
    prioritySelect,
    eventWithAsignment
  };
};

export default useLoadServices;
